import { Component, createElement } from 'react';
import { PaymentCard } from '@mews-framework/payments/cards';

export default function paymentCardCvcFactory(
    inputElement: React.ComponentType<unknown & React.InputHTMLAttributes<HTMLInputElement>>
) {
    return class PaymentCardCvc extends Component<React.InputHTMLAttributes<HTMLInputElement>> {
        restrictCVC = (e: React.KeyboardEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            const digit = String.fromCharCode(e.which);
            if (!/^\d+$/.test(digit)) {
                return;
            }

            if (PaymentCard.hasTextSelected(target)) {
                return;
            }

            const val = target.value + digit;
            if (val.length > 4) {
                e.preventDefault();
            }
        };

        reFormatCVC = (
            e:
                | React.KeyboardEvent<HTMLInputElement>
                | React.ClipboardEvent<HTMLInputElement>
                | React.ChangeEvent<HTMLInputElement>
        ) => {
            const target = e.target as HTMLInputElement;
            window.setTimeout(() => {
                target.value = target.value.replace(/\D/g, '').slice(0, 4);
            }, 0);
        };

        render() {
            const { onKeyPress, onPaste, onChange, onInput, ...other } = this.props;

            const props = {
                onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => {
                    PaymentCard.restrictNumeric(e);
                    this.restrictCVC(e);
                    if (onKeyPress) {
                        onKeyPress(e);
                    }
                },
                onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                    this.reFormatCVC(e);
                    if (onPaste) {
                        onPaste(e);
                    }
                },
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    this.reFormatCVC(e);
                    if (onChange) {
                        onChange(e);
                    }
                },
                onInput: (e: React.KeyboardEvent<HTMLInputElement>) => {
                    this.reFormatCVC(e);
                    if (onInput) {
                        onInput(e);
                    }
                },
            };
            const Input = createElement(inputElement, {
                ...props,
                ...other,
                type: 'tel',
            });

            return Input;
        }
    };
}
